import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { XML_CHARKEY } from "./interfaces.js";
import { RestError } from "@azure/core-rest-pipeline";
import { MapperTypeNames } from "./serializer.js";
import { getOperationRequestInfo } from "./operationHelpers.js";
var defaultJsonContentTypes = ["application/json", "text/json"];
var defaultXmlContentTypes = ["application/xml", "application/atom+xml"];
/**
 * The programmatic identifier of the deserializationPolicy.
 */

export var deserializationPolicyName = "deserializationPolicy";
/**
 * This policy handles parsing out responses according to OperationSpecs on the request.
 */

export function deserializationPolicy() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _a, _b, _c, _d, _e, _f, _g;

  var jsonContentTypes = (_b = (_a = options.expectedContentTypes) === null || _a === void 0 ? void 0 : _a.json) !== null && _b !== void 0 ? _b : defaultJsonContentTypes;
  var xmlContentTypes = (_d = (_c = options.expectedContentTypes) === null || _c === void 0 ? void 0 : _c.xml) !== null && _d !== void 0 ? _d : defaultXmlContentTypes;
  var parseXML = options.parseXML;
  var serializerOptions = options.serializerOptions;
  var updatedOptions = {
    xml: {
      rootName: (_e = serializerOptions === null || serializerOptions === void 0 ? void 0 : serializerOptions.xml.rootName) !== null && _e !== void 0 ? _e : "",
      includeRoot: (_f = serializerOptions === null || serializerOptions === void 0 ? void 0 : serializerOptions.xml.includeRoot) !== null && _f !== void 0 ? _f : false,
      xmlCharKey: (_g = serializerOptions === null || serializerOptions === void 0 ? void 0 : serializerOptions.xml.xmlCharKey) !== null && _g !== void 0 ? _g : XML_CHARKEY
    }
  };
  return {
    name: deserializationPolicyName,
    sendRequest: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, next) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return next(request);

              case 2:
                response = _context.sent;
                return _context.abrupt("return", deserializeResponseBody(jsonContentTypes, xmlContentTypes, response, updatedOptions, parseXML));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sendRequest(_x, _x2) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  };
}

function getOperationResponseMap(parsedResponse) {
  var result;
  var request = parsedResponse.request;
  var operationInfo = getOperationRequestInfo(request);
  var operationSpec = operationInfo === null || operationInfo === void 0 ? void 0 : operationInfo.operationSpec;

  if (operationSpec) {
    if (!(operationInfo === null || operationInfo === void 0 ? void 0 : operationInfo.operationResponseGetter)) {
      result = operationSpec.responses[parsedResponse.status];
    } else {
      result = operationInfo === null || operationInfo === void 0 ? void 0 : operationInfo.operationResponseGetter(operationSpec, parsedResponse);
    }
  }

  return result;
}

function shouldDeserializeResponse(parsedResponse) {
  var request = parsedResponse.request;
  var operationInfo = getOperationRequestInfo(request);
  var shouldDeserialize = operationInfo === null || operationInfo === void 0 ? void 0 : operationInfo.shouldDeserialize;
  var result;

  if (shouldDeserialize === undefined) {
    result = true;
  } else if (typeof shouldDeserialize === "boolean") {
    result = shouldDeserialize;
  } else {
    result = shouldDeserialize(parsedResponse);
  }

  return result;
}

function deserializeResponseBody(_x3, _x4, _x5, _x6, _x7) {
  return _deserializeResponseBody.apply(this, arguments);
}

function _deserializeResponseBody() {
  _deserializeResponseBody = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(jsonContentTypes, xmlContentTypes, response, options, parseXML) {
    var parsedResponse, operationInfo, operationSpec, responseSpec, _handleErrorResponse, error, shouldReturnResponse, valueToDeserialize, restError;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return parse(jsonContentTypes, xmlContentTypes, response, options, parseXML);

          case 2:
            parsedResponse = _context2.sent;

            if (shouldDeserializeResponse(parsedResponse)) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", parsedResponse);

          case 5:
            operationInfo = getOperationRequestInfo(parsedResponse.request);
            operationSpec = operationInfo === null || operationInfo === void 0 ? void 0 : operationInfo.operationSpec;

            if (!(!operationSpec || !operationSpec.responses)) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", parsedResponse);

          case 9:
            responseSpec = getOperationResponseMap(parsedResponse);
            _handleErrorResponse = handleErrorResponse(parsedResponse, operationSpec, responseSpec, options), error = _handleErrorResponse.error, shouldReturnResponse = _handleErrorResponse.shouldReturnResponse;

            if (!error) {
              _context2.next = 15;
              break;
            }

            throw error;

          case 15:
            if (!shouldReturnResponse) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt("return", parsedResponse);

          case 17:
            if (!responseSpec) {
              _context2.next = 33;
              break;
            }

            if (!responseSpec.bodyMapper) {
              _context2.next = 31;
              break;
            }

            valueToDeserialize = parsedResponse.parsedBody;

            if (operationSpec.isXML && responseSpec.bodyMapper.type.name === MapperTypeNames.Sequence) {
              valueToDeserialize = typeof valueToDeserialize === "object" ? valueToDeserialize[responseSpec.bodyMapper.xmlElementName] : [];
            }

            _context2.prev = 21;
            parsedResponse.parsedBody = operationSpec.serializer.deserialize(responseSpec.bodyMapper, valueToDeserialize, "operationRes.parsedBody", options);
            _context2.next = 29;
            break;

          case 25:
            _context2.prev = 25;
            _context2.t0 = _context2["catch"](21);
            restError = new RestError("Error ".concat(_context2.t0, " occurred in deserializing the responseBody - ").concat(parsedResponse.bodyAsText), {
              statusCode: parsedResponse.status,
              request: parsedResponse.request,
              response: parsedResponse
            });
            throw restError;

          case 29:
            _context2.next = 32;
            break;

          case 31:
            if (operationSpec.httpMethod === "HEAD") {
              // head methods never have a body, but we return a boolean to indicate presence/absence of the resource
              parsedResponse.parsedBody = response.status >= 200 && response.status < 300;
            }

          case 32:
            if (responseSpec.headersMapper) {
              parsedResponse.parsedHeaders = operationSpec.serializer.deserialize(responseSpec.headersMapper, parsedResponse.headers.toJSON(), "operationRes.parsedHeaders", {
                xml: {},
                ignoreUnknownProperties: true
              });
            }

          case 33:
            return _context2.abrupt("return", parsedResponse);

          case 34:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[21, 25]]);
  }));
  return _deserializeResponseBody.apply(this, arguments);
}

function isOperationSpecEmpty(operationSpec) {
  var expectedStatusCodes = Object.keys(operationSpec.responses);
  return expectedStatusCodes.length === 0 || expectedStatusCodes.length === 1 && expectedStatusCodes[0] === "default";
}

function handleErrorResponse(parsedResponse, operationSpec, responseSpec, options) {
  var _a;

  var isSuccessByStatus = 200 <= parsedResponse.status && parsedResponse.status < 300;
  var isExpectedStatusCode = isOperationSpecEmpty(operationSpec) ? isSuccessByStatus : !!responseSpec;

  if (isExpectedStatusCode) {
    if (responseSpec) {
      if (!responseSpec.isError) {
        return {
          error: null,
          shouldReturnResponse: false
        };
      }
    } else {
      return {
        error: null,
        shouldReturnResponse: false
      };
    }
  }

  var errorResponseSpec = responseSpec !== null && responseSpec !== void 0 ? responseSpec : operationSpec.responses.default;
  var initialErrorMessage = ((_a = parsedResponse.request.streamResponseStatusCodes) === null || _a === void 0 ? void 0 : _a.has(parsedResponse.status)) ? "Unexpected status code: ".concat(parsedResponse.status) : parsedResponse.bodyAsText;
  var error = new RestError(initialErrorMessage, {
    statusCode: parsedResponse.status,
    request: parsedResponse.request,
    response: parsedResponse
  }); // If the item failed but there's no error spec or default spec to deserialize the error,
  // we should fail so we just throw the parsed response

  if (!errorResponseSpec) {
    throw error;
  }

  var defaultBodyMapper = errorResponseSpec.bodyMapper;
  var defaultHeadersMapper = errorResponseSpec.headersMapper;

  try {
    // If error response has a body, try to deserialize it using default body mapper.
    // Then try to extract error code & message from it
    if (parsedResponse.parsedBody) {
      var parsedBody = parsedResponse.parsedBody;
      var deserializedError;

      if (defaultBodyMapper) {
        var valueToDeserialize = parsedBody;

        if (operationSpec.isXML && defaultBodyMapper.type.name === MapperTypeNames.Sequence) {
          valueToDeserialize = [];
          var elementName = defaultBodyMapper.xmlElementName;

          if (typeof parsedBody === "object" && elementName) {
            valueToDeserialize = parsedBody[elementName];
          }
        }

        deserializedError = operationSpec.serializer.deserialize(defaultBodyMapper, valueToDeserialize, "error.response.parsedBody", options);
      }

      var internalError = parsedBody.error || deserializedError || parsedBody;
      error.code = internalError.code;

      if (internalError.message) {
        error.message = internalError.message;
      }

      if (defaultBodyMapper) {
        error.response.parsedBody = deserializedError;
      }
    } // If error response has headers, try to deserialize it using default header mapper


    if (parsedResponse.headers && defaultHeadersMapper) {
      error.response.parsedHeaders = operationSpec.serializer.deserialize(defaultHeadersMapper, parsedResponse.headers.toJSON(), "operationRes.parsedHeaders");
    }
  } catch (defaultError) {
    error.message = "Error \"".concat(defaultError.message, "\" occurred in deserializing the responseBody - \"").concat(parsedResponse.bodyAsText, "\" for the default response.");
  }

  return {
    error: error,
    shouldReturnResponse: false
  };
}

function parse(_x8, _x9, _x10, _x11, _x12) {
  return _parse.apply(this, arguments);
}

function _parse() {
  _parse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(jsonContentTypes, xmlContentTypes, operationResponse, opts, parseXML) {
    var _a, text, contentType, contentComponents, body, msg, errCode, e;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!((_a = operationResponse.request.streamResponseStatusCodes) === null || _a === void 0 ? void 0 : _a.has(operationResponse.status)) && operationResponse.bodyAsText)) {
              _context3.next = 26;
              break;
            }

            text = operationResponse.bodyAsText;
            contentType = operationResponse.headers.get("Content-Type") || "";
            contentComponents = !contentType ? [] : contentType.split(";").map(function (component) {
              return component.toLowerCase();
            });
            _context3.prev = 4;

            if (!(contentComponents.length === 0 || contentComponents.some(function (component) {
              return jsonContentTypes.indexOf(component) !== -1;
            }))) {
              _context3.next = 10;
              break;
            }

            operationResponse.parsedBody = JSON.parse(text);
            return _context3.abrupt("return", operationResponse);

          case 10:
            if (!contentComponents.some(function (component) {
              return xmlContentTypes.indexOf(component) !== -1;
            })) {
              _context3.next = 18;
              break;
            }

            if (parseXML) {
              _context3.next = 13;
              break;
            }

            throw new Error("Parsing XML not supported.");

          case 13:
            _context3.next = 15;
            return parseXML(text, opts.xml);

          case 15:
            body = _context3.sent;
            operationResponse.parsedBody = body;
            return _context3.abrupt("return", operationResponse);

          case 18:
            _context3.next = 26;
            break;

          case 20:
            _context3.prev = 20;
            _context3.t0 = _context3["catch"](4);
            msg = "Error \"".concat(_context3.t0, "\" occurred while parsing the response body - ").concat(operationResponse.bodyAsText, ".");
            errCode = _context3.t0.code || RestError.PARSE_ERROR;
            e = new RestError(msg, {
              code: errCode,
              statusCode: operationResponse.status,
              request: operationResponse.request,
              response: operationResponse
            });
            throw e;

          case 26:
            return _context3.abrupt("return", operationResponse);

          case 27:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[4, 20]]);
  }));
  return _parse.apply(this, arguments);
}